import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {BaseComponent} from '../../core/base.component';
import {AuthService} from '../../core/security/auth.service';
import {RolesEnum} from '../../core/security/roles.enum';
import {NotificationService} from '../../notification/notification.service';
import {ProMessagingTemplateService} from '../pro-messaging-template.service';
import {FilterOptionModel} from '../../dialogs/grid-filter/filter-option.model';
import { FlexModule } from '@angular/flex-layout';
import { GridFilterComponent } from '../../dialogs/grid-filter/grid-filter.component';
import { FilterRowAdditionalContentComponent } from '../../dialogs/grid-filter/filter-row-additional-content.component';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { ProMessagingTemplatesGridComponent } from './grid/pro-messaging-templates-grid.component';

@Component({
    selector: 'app-pro-messaging-template-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        GridFilterComponent,
        FilterRowAdditionalContentComponent,
        NgIf,
        MatButton,
        MatTooltip,
        ProMessagingTemplatesGridComponent,
    ],
})
export class ProMessagingTemplateListComponent extends BaseComponent implements OnInit, OnDestroy {

  filterChangeEvent = new EventEmitter<any>();
  filterOptions: FilterOptionModel[] = [];

  public detailsUrl: string;

  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title, authService: AuthService,
              public templateService: ProMessagingTemplateService,
              private router: Router) {
    super(route, headerService, titleService, authService);

    this.viewRoles = [RolesEnum.MessagingTemplateView, RolesEnum.MessagingTemplateEdit, RolesEnum.MessagingTemplateDelete,
      RolesEnum.MessagingPrivateTemplateView, RolesEnum.MessagingPrivateTemplateEdit, RolesEnum.MessagingPrivateTemplateDelete];

    this.editRoles = [RolesEnum.MessagingTemplateEdit, RolesEnum.MessagingTemplateDelete,
      RolesEnum.MessagingPrivateTemplateEdit, RolesEnum.MessagingPrivateTemplateDelete];

    this.deleteRoles = [RolesEnum.MessagingTemplateDelete, RolesEnum.MessagingPrivateTemplateDelete];

    this.detailsUrl = '../';
  }

  async ngOnInit() {
    await super.ngOnInit();

    this.initFilterOptions();
  }

  public onCreateTemplate() {
    this.router.navigate([this.detailsUrl, 'edit', 'new'], {relativeTo: this.route});
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.headerService.hideSearchInput();
  }

  onFilterChanged(filter: any) {
    this.filterChangeEvent.emit(filter);
  }

  initFilterOptions(): void {
    this.filterOptions = [
      {
        filterKey: 'searchText',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Any'
      },
      {
        filterKey: 'type',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Public',
        displayValue: 'Yes',
        value: 1,
        searchText: 'Public: Yes',
      },
      {
        filterKey: 'type',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Private',
        displayValue: 'Yes',
        value: 2,
        searchText: 'Private: Yes',
      },
    ];

    for (const category of this.templateService.categories) {
      this.filterOptions.push({
        filterKey: 'category',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Category',
        displayValue: category.text,
        value: category.id,
        searchText: `Category: ${category.text}`,
      });
    }

  }
}
